import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../../../shared/Reveal/Reveal';
import checkIcon from '../../../../assets/images/markets/other/marketaccess/CheckCircle.svg';
import accessImage from '../../../../assets/images/markets/other/marketaccess/main.jpg';
import './MarketAccess.css';

const MarketAccess = ({ title, text, items, cta, checkIcon: checkIconSrc, image }) => {
  if (!title) {
    return null;
  }

  return (
    <section className="market-access">
      <div className="market-access__inner">
        <Reveal className="market-access__copy">
          <h2 className="market-access__title">{title}</h2>
          {text ? <p className="market-access__text">{text}</p> : null}
          {items?.length ? (
            <ul className="market-access__list">
              {items.map((item) => (
                <li key={item} className="market-access__item">
                  <img
                    className="market-access__check"
                    src={checkIconSrc || checkIcon}
                    alt=""
                    aria-hidden="true"
                  />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          ) : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="market-access__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </Reveal>

        <Reveal className="market-access__media" delay={80}>
          <img
            className="market-access__image"
            src={image || accessImage}
            alt=""
            aria-hidden="true"
          />
        </Reveal>
      </div>
    </section>
  );
};

export default MarketAccess;
